import { Outlet, useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { CartProvider } from "@/hooks/useCart";

const MainLayout = () => {
    const { businessName } = useParams();
    return (
        <>
            <CartProvider businessName={businessName}>
                <header className="pb-10 bg-shade-light">
                    <Navbar />
                </header>
                <main className="bg-shade-light">
                    <Outlet />
                </main>
                <Footer />
            </CartProvider>
        </>
    );
};
export default MainLayout;
